import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../featurs/user/userSlice";
import movieReducer from '../featurs/movie/movieSlice'

const store = configureStore({
    reducer: {
        user: userReducer,
        movie: movieReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false
        })
});

export default store;